interface DiscussionTogglePillProps {
  on: boolean;
}

export const DiscussionTogglePill = ({ on }: DiscussionTogglePillProps): JSX.Element => (
  <div
    className={`DiscussionTogglePill ${on ? "DiscussionTogglePill_on" : "DiscussionTogglePill_off"}`}
    role="presentation"
  >
    <div className="DiscussionToggleThumb" />
  </div>
);
